import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";

import ErrorMessage from "components/ErrorMessage";
import { isAdmin, isCustomerAdmin } from "utils/formatter";
import BackButton from "components/BackButton";

import CTextField from "uis/CTextField";

const styles = {
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    width: 500,
    margin: "50px auto 20px"
  },
  description: {
    padding: 20,
    marginBottom: 10
  },
  btnWrapper: {
    display: "block",
    marginTop: 30,
    textAlign: "center"
  }
};

class SendResetPassword extends React.Component {
  componentWillUnmount() {
    this.props.init();
  }

  render() {
    const { classes, customerId, loginId, errors } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>パスワード再設定</h2>
          <BackButton link={isCustomerAdmin() ? "/" : "/login"} />
        </div>

        <div className={classes.main}>
          <div className={classes.description}>
            {`パスワードをお忘れの方は、${
              isAdmin() ? "管理者ID" : "顧客IDと担当者ID"
            }を入力後、
          「リセットメール送信」ボタンをクリックして下さい。`}
          </div>

          <ErrorMessage messages={errors} />

          {isCustomerAdmin() && (
            <div>
              <CTextField
                id="customerId"
                label="顧客ID"
                value={customerId || ""}
                onChange={e =>
                  this.props.changeForm("customerId", e.target.value)
                }
                fullWidth
                margin="dense"
              />
              <br />
            </div>
          )}

          <CTextField
            id="login-id"
            label={isAdmin() ? "管理者ID" : "担当者ID"}
            value={loginId}
            margin="dense"
            onChange={e => this.props.changeForm("loginId", e.target.value)}
            fullWidth
          />

          <div className={classes.btnWrapper}>
            <Button
              raised
              onClick={() =>
                this.props.handleSubmit(customerId, loginId, isAdmin())
              }
            >
              リセットメール送信
            </Button>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SendResetPassword);



// WEBPACK FOOTER //
// ./src/components/SendResetPassword.jsx